/// <reference path="converters.ts" />
/// <reference path="decorators.ts" />
/// <reference path="logger.ts" />
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Expression } from './expression';
import { LogLevel } from './logger';
import { INSTANCE_SCOPE_VAR } from './types';
import { Utils } from './utils';
import { CustomElementUtils } from './utils-customelement';
import { Watch } from './decorators';
import { PropertyConverters } from './converters';
//namespace Pacem.Components {
export class PacemEventTarget extends HTMLElement {
    constructor() {
        super();
        this._isReady = false;
        this.emitHandler = (evt) => {
            // no handlers processed if the element is disabled.
            if (!this.disabled) {
                this.emit(evt);
            }
        };
    }
    /**
     * Executes the relevant handler defined in the `on-{evt.type}` attribute, if any.
     * @param evt {Event} the event to be fired
     */
    emit(evt) {
        if (evt.defaultPrevented) {
            // skip if evt was canceled
            return;
        }
        this._emitCore(evt);
    }
    _emitCore(evt) {
        var attrName = `on-${evt.type.toLowerCase()}`;
        if (attrName in this.attributes) {
            this.log(LogLevel.Debug, `Calling ${attrName} handler for event ${evt.type}`);
            var attrBody = this.attributes[attrName].value;
            var expression = Expression.parse(attrBody, this);
            if (!Utils.isNull(expression) && expression.pending !== true) {
                expression.evaluatePlus({ '$event': evt });
            }
        }
    }
    handle(evt, detail) {
        if (typeof evt === 'string') {
            evt = Utils.isNull(detail) ? new Event(evt, { cancelable: false }) : new CustomEvent(evt, { cancelable: false, detail });
        }
        this.emit(evt);
    }
    /** Gets whether the element has been completely loaded alongside with the other pieces of the DOM. */
    get isReady() {
        return this._isReady;
    }
    connectedCallback() {
        CustomElementUtils.setAttachedPropertyValue(this, INSTANCE_SCOPE_VAR, CustomElementUtils.findScopeContext(this));
        this.log(LogLevel.Debug, `Connected.`);
    }
    disconnectedCallback() {
        this._isReady = false;
        this.dispatchEvent(new Event('unload'));
        CustomElementUtils.deleteAttachedPropertyValue(this, INSTANCE_SCOPE_VAR);
        this.log(LogLevel.Debug, `Disconnected.`);
    }
    viewActivatedCallback() {
        this._isReady = true;
        this.log(LogLevel.Debug, `Loaded (view activated).`);
        this.dispatchEvent(new Event('load'));
    }
    /**
     * Manages the value change of a watched property.
     * @param name {string} property name
     * @param old {any} former property value
     * @param val {any} new/current property value
     * @param first {boolean} whether is the first change (right before view activation) or not
     */
    propertyChangedCallback(name, old, val, first) {
        if (first)
            this.log(LogLevel.Log, `Property "${name}" changed at start-up`);
        else
            this.log(LogLevel.Log, `Property "${name}" changed from ${old} to ${val}`);
    }
    /**
     * Wraps the native dispatchEvent in order to emit `on-{evt-type}` handler, if any.
     * @param evt {Event} the event to be fired
     */
    dispatchEvent(evt) {
        // no events dispatched if the element is disabled.
        if (this.disabled) {
            return false;
        }
        this.log(LogLevel.Log, `Dispatching event "${evt.type}"`);
        const ret = super.dispatchEvent(evt);
        this.emit(evt);
        return ret;
    }
    /**
     * Logs a message if a logger is available.
     * @param level {LogLevel} Level of log
     * @param message {String} Content
     * @param category {String} Grouping category
     */
    log(level, message, category = this.localName + (this.id ? '#' + this.id : '')) {
        this.logger && typeof this.logger.log === 'function' && this.logger.log(level, message, category);
    }
    /** Refreshes all the properties corresponding to explicit binding attributes. */
    refreshBindings() {
        // refresh all the bindings
        for (let j = 0; j < this.attributes.length; j++) {
            let attr = this.attributes.item(j), isBinding = CustomElementUtils.isBindingAttribute(attr.value);
            if (!isBinding)
                continue;
            let prop = CustomElementUtils.kebabToCamel(attr.name);
            let binding = CustomElementUtils.parseBindingAttribute(attr.value, this);
            this[prop] = binding.evaluate();
        }
    }
}
__decorate([
    Watch({ reflectBack: true, converter: PropertyConverters.Boolean })
], PacemEventTarget.prototype, "disabled", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemEventTarget.prototype, "logger", void 0);
//}
